import React from 'react';

import List from './message-type/List'

function MessageType(){
	return(
	
			<List/>
			
		
	);
}

export default MessageType;